import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-free-trial-style-four',
  templateUrl: './free-trial-style-four.component.html',
  styleUrls: ['./free-trial-style-four.component.scss']
})
export class FreeTrialStyleFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
